// extracted by mini-css-extract-plugin
export default {"logicBuilderHeader":"LogicBuilderHeader_logicBuilderHeader__Pz-Jm","text":"LogicBuilderHeader_text__0+dLY","grabIconButton":"LogicBuilderHeader_grabIconButton__IH0F2"};